import { CreatePinScreenComponent } from '@1bill-app/components/create-pin-screen/create-pin-screen.component';
import { LockScreenComponent } from '@1bill-app/components/lock-screen/lock-screen.component';
import { ROUTE_BASE } from '@1bill-app/constants';
import { AuthGuard, UnAuthGuard } from '@1bill-app/services/auth/auth.guard';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    // canActivate: [UnAuthGuard],
    children: [
      // { path: 'signin', redirectTo: ROUTE_BASE, pathMatch: 'full' }, // handle legacy redirects
      // { path: 'signup', redirectTo: ROUTE_BASE, pathMatch: 'full' }, // handle legacy redirects
      {
        path: 'verify-email',
        loadChildren: () =>
          import('./verify-email/verify-email.module').then((m) => m.VerifyEmailPageModule),
      },
      {
        path: 'verification',
        loadChildren: () =>
          import('./verification/verification.module').then((m) => m.VerificationPageModule),
      },
      {
        path: 'recover-password',
        loadChildren: () =>
          import('./recover-password/recover-password.module').then(
            (m) => m.RecoverPasswordPageModule,
          ),
          canActivate: [UnAuthGuard],
      },
      {
        path: '',
        redirectTo: ROUTE_BASE,
        pathMatch: 'full',
      },
    ],
  },
  {
    path: 'landing',
    loadChildren: () => import('../landing-page/landing-page.module').then((m) => m.LandingPagePageModule),
    canActivate: [UnAuthGuard],
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then((m) => m.LoginPageModule),
    canActivate: [UnAuthGuard],
  },
  {
    path: 'create-account',
    loadChildren: () =>
      import('./create-account/create-account.module').then((m) => m.CreateAccountPageModule),
    canActivate: [UnAuthGuard],
  },
  {
    path: 'update-name',
    loadChildren: () =>
      import('./update-name/update-name.module').then((m) => m.UpdateNamePageModule),
      canActivate: [AuthGuard],
  },
  {
    path: 'mobile-number',
    loadChildren: () => import('./mobile-number/mobile-number.module').then(m => m.MobileNumberPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'mobile-verification',
    loadChildren: () => import('./mobile-verification/mobile-verification.module').then(m => m.MobileVerificationPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'post-mobile-verification',
    loadChildren: () => import('./post-mobile-verification/post-mobile-verification.module').then(m => m.PostMobileVerificationPageModule),
    canActivate: [AuthGuard],
  },
  {
    path: 'terms',
    loadChildren: () => import('./terms/terms.module').then((m) => m.TermsPageModule),
  },
  {
    path: 'lock',
    component: LockScreenComponent,
  },
  {
    path: 'create-pin',
    component: CreatePinScreenComponent,
  },
  {
    path: 'no-network',
    loadChildren: () => import('./no-network/no-network.module').then((m) => m.NoNetworkPageModule),
  },
  {
    path: '',
    redirectTo: ROUTE_BASE,
    pathMatch: 'full',
  },
  {
    path: 'allow-notifications',
    loadChildren: () =>
      import('./allow-notifications/allow-notifications.module').then(
        (m) => m.AllowNotificationsPageModule,
      ),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
